import type { ReactNode } from "react";
import { Button, Group, Modal, Text } from "@mantine/core";

interface ReturnUnitModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  /** The confirmation prompt body (varies per view). */
  children: ReactNode;
}

// Shared "Return Unit to Storage" confirmation dialog. The dock-status and
// customer-operations views both trigger the same return-unit action; only the
// prompt copy differs, so it's passed in as children.
export function ReturnUnitModal({
  opened,
  onClose,
  onConfirm,
  isPending,
  children,
}: ReturnUnitModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text fw={600} fz="lg" c="primary.6">
          Return Unit to Storage
        </Text>
      }
      centered
      radius="lg"
      size={480}
    >
      <Text c="dimmed" fz="sm" mb="xl">
        {children}
      </Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="subtle" color="gray" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button color="primary" loading={isPending} onClick={onConfirm}>
          Return Unit
        </Button>
      </Group>
    </Modal>
  );
}
